"use strict";
module.exports = {
    entityModel: 'supplier',
    events: {
        SUPPLIER_PUBLISHED_ON_QVANTI: 'SUPPLIER_PUBLISHED_ON_QVANTI',
        SUPPLIER_UNPUBLISHED_ON_QVANTI: 'SUPPLIER_UNPUBLISHED_ON_QVANTI',
        SUPPLIER_UPDATED: 'SUPPLIER_UPDATED',
        SUPPLIER_CREATED: 'SUPPLIER_CREATED',
        SUPPLIER_METADATA_CHANGED: 'SUPPLIER_METADATA_CHANGED',
    },
    actions: {
        get: 'v1.supplier.get',
        list: 'v1.supplier.list',
        setOwningSupplierOrganization: 'v1.supplier.setOwningSupplierOrganization',
        suggestNewSupplier: 'v1.supplier.suggestNewSupplier',
        ensureOrders: 'v1.supplier.ensureOrders',
        requestDemo: 'v1.supplier.requestDemo',
        writeSupplier: 'v1.supplier.writeSupplier',
        disconnectFromExtend: 'v1.supplier.disconnectFromExtend',
        upsert: 'v1.supplier.upsert',
        upsertWhenEmpty: 'v1.supplier.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplier.updateWhenEmpty',
        update: 'v1.supplier.update',
    },
    invoiceCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    preDefinedAccounts: {
        4000: '4000',
        4004: '4004',
        4005: '4005',
        4010: '4010',
        4011: '4011',
        4014: '4014',
        4017: '4017',
    },
};
